// https://dev.to/jam3/managing-env-variables-for-provisional-builds-h37

export default {
    PRODUCTION: process.env.NODE_ENV === 'production',
    FeatureFlags:{
        attachmentSupport:false
    }
}